
import React from 'react'
import {  FiSearch } from 'react-icons/fi';
import { motion } from "framer-motion"

export const HeroGradient = () =>{


    return (
        <div className='hero-gradient'>
            <div className='hero centerize '>
                <div className="heading-one flex">
                <div className='head flex'>
                       <div className="flex-start">
                       <h1 className='title'> Find Easy {` `}
                            {/**  
                            <Typed
                                strings={[
                                    'Hotel',
                                    'Real Estate',
                                    'Land',
                                    'Place',
                                    'Template',
                                    'Restaurant', 'Job', 
                                ]} 
                                typeSpeed={50}
                                backSpeed={70}
                            /> 
                            **/}
                            
                        </h1>
                   
                       </div>
                        <p className='description'>
                             Discover new lands. Easy to buy & sell your property with Finderland, Top-Class Real Estate Center
                        </p>
                </div>
                <div className="searchbar">
                   <div className="input">
                        <input placeholder='Search' />
                        <FiSearch />
                   </div>
                </div>
            </div>
           </div>
        

            <div className="hero-overlay">
                    <motion.div
                        className='blue-circle'
                        initial={{ right:'-7em', filter:'blur(150px)' }}
                        animate={{ right:'-20em', filter:'blur(70px)' }}
                        transition={{ 
                            duration:2,
                            repeat: Infinity,
                            repeatType: "reverse",
                            type: "tween",
                            ease: [0.17, 0.67, 0.83, 0.67] 
                        }}
                    />
                      <motion.div
                        className='green-circle'
                        initial={{ left:'-2em', top:'15em', filter:'blur(110px)' }}
                        animate={{ left:'-1em', top:'30em', filter:'blur(50px)' }}
                        transition={{ 
                            duration:2,
                            repeat: Infinity,
                            repeatType: "reverse",
                            type: "tween",
                            ease: [0.17, 0.67, 0.83, 0.67] 
                        }}
                    />
            </div>
        </div>
    )
} 
